module.exports = __webpack_public_path__ + "img/link.3ed2f8c5.svg";